import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import LanguageToggle from '../components/LanguageToggle';
import { trackMenuOpen } from '../utils/ga4Events';
import { useNavigate, Link } from 'react-router-dom';
import api from '../config/api';
import BuyMore from '../components/BuyMore';

function Menu() {
  const { t, i18n } = useTranslation();
  const [showMenu, setShowMenu] = useState(true);
  const navigate = useNavigate();
  const language = localStorage.getItem("appLanguage") || "en";
  const [openPopup, setOpenPopup] = useState(false);

  useEffect(() => {
    trackMenuOpen();
  }, []);

  // register click event for analytics
  const handleMenuItemClick = (path) => {
    trackMenuItemClick(path);
    navigate(path);
  };

  const trackMenuItemClick = (path) => {
    if (path === '/how-to-play') {
      api.post('/interaction/track', { action: 'HOW_TO_PLAY_CLICKED' });
    }
  };

  return (
    <>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <link rel="shortcut icon" href="assets/images/favicon.ico" type="image/x-icon" />
      <link rel="stylesheet" href="https://use.typekit.net/hiu4ulc.css" />
      <link rel="stylesheet" href="assets/css/styles.css?ver=2.0" />
      <title>Home | Britannia</title>

      <div className="page-wrapper">
        <div className="main-wrapper yellow-bg">

          {/* ══ DESKTOP ══ */}
          <div className="d-frame-outer desktop-only">
            <img src="assets/images/desktop-star.webp" className="d-frame-star-bg" />
            <span className="d-frame-corner tl" />
            <span className="d-frame-corner tr" />
            <span className="d-frame-corner bl" />
            <span className="d-frame-corner br" />
            <div className="d-frame-border-outer">
              <div className="d-frame-border">
                <div className="d-frame-border-inner">
                  <div className="d-frame-canvas">
                    <div className="d-frame-content">
                      <div className="desktop-center">
                        <div className="desktop-content-box">
                          <h3>{t("common.desktopInterest")}</h3>
                          <img src="assets/images/desktop-logo-milk-bikis.webp" className="desktop-logo" alt="Milk Bikis Logo" />
                          <div className="desktop-qr-box">
                            <span className="qr-corner qr-corner-tl" />
                            <span className="qr-corner qr-corner-tr" />
                            <span className="qr-corner qr-corner-bl" />
                            <span className="qr-corner qr-corner-br" />
                            <div className="qr-left">
                              <p className="qr-text">{t("common.desktopQr")}</p>
                            </div>
                            <div className="qr-right">
                              <img src="assets/images/desktop-qr.svg" alt="QR Code" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ══ MOBILE ══ */}
          <div className="frame-outer mobile-only">
            <span className="frame-corner tl" />
            <span className="frame-corner tr" />
            <span className="frame-corner bl" />
            <span className="frame-corner br" />
            <div className="frame-border-outer">
              <div className="frame-border">
                <div className="frame-border-inner">
                  <div className="frame-canvas">
                    <div className="frame-content">
                      <div className={`kural-screen`}>

                        <div className="kural-top">
                          <div className="kural-head-container">
                            <div className="logo-head">
                              <div className="camera-sc-logo-wrap">
                                <img src="assets/images/animate-britania-logo.webp" alt="Britannia" className="camera-sc-logo camera-sc-logo-1" />

                                <img src="assets/images/animate-milk-bikkis-logo.webp" alt="Milk Bikis" className="camera-sc-logo camera-sc-logo-2" />
                              </div>
                              <img src="assets/images/sign-up-head-text.webp" className="top-logo-text" alt="Top Logo" onClick={() => navigate("/home")} />

                              <div className="menu-bars">
                                <span></span>
                                <span></span>
                                <span></span>
                              </div>
                            </div>

                            {/* <LanguageToggle /> */}
                          </div>
                          <div className="menu-popup-container">
                            <div className="menu-popup-content">
                              <div className="menu-popup-header">
                                <img src={language === "ta" ? "assets/images/menu-icon-tamil.webp" : "assets/images/menu-icon.webp"} className="menu-popup-icon" alt="Menu Icon" style={{
                                  width: language === "ta" ? "" : "",
                                }} />
                                <button
                                  className="howtp-close-btn"
                                  data-close-popup=".menu-popup-container"
                                  onClick={() => window.history.back()}
                                  aria-label="Close menu"
                                >
                                  <img src="assets/images/close-icon.webp" alt="Close" />
                                </button>
                              </div>

                              <div className="menu-popup-body-wrapper">
                                <div className="menu-popup-body">
                                  <ul className="menu-popup-list">
                                    <li className="menu-popup-item" onClick={() => handleMenuItemClick('/rewards')} style={{ padding: language === "ta" ? "8px 0" : "13px 0", }}>
                                      <img src="assets/images/num1.webp" alt="01" />
                                      <span className="menu-item-text">{t("menu.rewards")}  </span>
                                    </li>
                                    <li className="menu-popup-item" onClick={() => handleMenuItemClick('/how-to-play')} style={{ padding: language === "ta" ? "8px 0" : "13px 0", }}>
                                      <img src="assets/images/num2.webp" alt="02" />
                                      <span className="menu-item-text">{t("menu.howToPlay")}</span>
                                    </li>
                                    <li className="menu-popup-item" onClick={() => handleMenuItemClick('/contact-us')} style={{ padding: language === "ta" ? "8px 0" : "13px 0", }}>
                                      <img src="assets/images/num3.webp" alt="03" />
                                      <span className="menu-item-text">{t("menu.contactUs")}</span>
                                    </li>
                                    <li className="menu-popup-item" onClick={() => handleMenuItemClick('/privacy-policy')} style={{ padding: language === "ta" ? "8px 0" : "13px 0", }}>
                                      <img src="assets/images/num4.webp" alt="04" />
                                      <span className="menu-item-text">{t("menu.privacyPolicy")}</span>
                                    </li>
                                    <li className="menu-popup-item" onClick={() => handleMenuItemClick('/tnc')} style={{ padding: language === "ta" ? "8px 0" : "13px 0", }}>
                                      <img src="assets/images/num5.webp" alt="05" />
                                      <span className="menu-item-text">{t("menu.termsAndConditions")}</span>
                                    </li>
                                    <li className="menu-popup-item" onClick={() => setOpenPopup(true)} style={{ padding: language === "ta" ? "8px 0" : "13px 0", }}>
                                      <svg width="30" height="30" viewBox="0 0 67 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M30.8802 14.16V42.88C30.8802 51.36 25.9202 57.04 15.4402 57.04C4.9602 57.04 0.000195324 51.36 0.000195324 42.88V14.16C0.000195324 5.67999 4.9602 -1.04904e-05 15.4402 -1.04904e-05C25.9202 -1.04904e-05 30.8802 5.67999 30.8802 14.16ZM11.8402 14.56V42.48C11.8402 44.96 12.8802 46.4 15.4402 46.4C18.0002 46.4 19.0402 44.96 19.0402 42.48V14.56C19.0402 12.08 18.0002 10.64 15.4402 10.64C12.8802 10.64 11.8402 12.08 11.8402 14.56ZM49.1246 21.2C50.7246 19.92 52.8846 19.28 55.2846 19.28C62.6446 19.28 66.9646 23.76 66.9646 32.32V42.88C66.9646 51.36 62.0046 57.04 51.5246 57.04C41.0446 57.04 36.0846 51.36 36.0846 42.88V31.44C36.0846 18.8 42.6446 7.35999 48.4846 0.799989H62.3246C56.8846 6.55999 51.6046 13.36 49.1246 21.2ZM47.9246 32.8V42.56C47.9246 45.04 48.9646 46.48 51.5246 46.48C54.0846 46.48 55.1246 45.04 55.1246 42.56V32.8C55.1246 30.32 54.0846 28.8 51.5246 28.8C48.9646 28.8 47.9246 30.32 47.9246 32.8Z" fill="black" />
                                      </svg>

                                      <span className="menu-item-text">{t("menu.buymore")}</span>
                                    </li>
                                  </ul>
                                </div>

                                <button className="btn-next menu-btn" type="button" onClick={() => window.history.back()}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    alignSelf: "center",
                                    justifyContent: "center",
                                    textAlign: "center",
                                    padding: "8px 0px",
                                  }}
                                >
                                  <span>{t("menu.goBack")}</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>

                </div>
                <div className="kural-bottom">
                  <div className="kural-steps">
                    <span style={{ fontSize: language === "ta" ? "6px" : "8px" }}>{t("dashboard.scanStep")}</span>
                    <img src="assets/images/right-arrow-icon.webp" alt="arrow" className="arrow-img" />
                    <span style={{ fontSize: language === "ta" ? "6px" : "8px" }}>{t("dashboard.completeStep")}</span>
                    <img src="assets/images/right-arrow-icon.webp" alt="arrow" className="arrow-img" />
                    <span style={{ fontSize: language === "ta" ? "6px" : "8px" }}>{t("dashboard.sendVideoStep")}</span>
                  </div>
                </div>
              </div>

            </div>

            {/* <div className="frame-footer">
              <p className="frame-footer-terms">
                <Link to="/tnc">{t("common.terms")}</Link> {t("common.and")} <Link to="/privacy-policy">{t("common.privacy")}</Link>
              </p>
            </div> */}
          </div>

        </div>
      </div>
      {openPopup && (
        <BuyMore onClose={() => setOpenPopup(false)} />
      )}
    </>
  )
}

export default Menu
